import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// 解决跳转相同的路由报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    if (to.path != from.path) {
      // window.location.reload()
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0 
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: ()=>import('@/views/home')
    },
    {
      path: '/home',
      name: 'home',
      component: ()=>import('@/views/home')
    },
    {
      path: '/index',
      name: 'home',
      component: ()=>import('@/views/home')
    },
    {
      path: '/aboutSketch',
      name: 'aboutSketch',
      component: () => import('@/views/aboutSketch')
    },
    {
      path: '/aboutCulture',
      name: 'aboutCulture',
      component: () => import('@/views/aboutCulture')
    },
    {
      path: '/aboutDuty',
      name: 'aboutDuty',
      component: () => import('@/views/aboutDuty')
    },
    {
      path: '/aboutSpeak',
      name: 'aboutSpeak',
      component: () => import('@/views/aboutSpeak')
    },
    {
      path: '/ecology',
      name: 'ecology',
      component: () => import('@/views/ecology')
    },
    // 生态
    {
      path: '/ecologyInfor',
      name: 'ecologyInfor',
      component: () => import('@/views/ecologyInfor')
    },
    {
      path: '/ecologyPark',
      name: 'ecologyPark',
      component: () => import('@/views/ecologyPark')
    },
    {
      path: '/ecologyAbout',
      name: 'ecologyAbout',
      component: () => import('@/views/ecologyAbout')
    },
     {
      path: '/ecologydata',
      name: 'ecologydata',
      component: () => import('@/views/ecologydata')
    },
    {
      path: '/ecologyDetail',
      name: 'ecologyDetail',
      component: () => import('@/views/ecologyDetail')
    },
    // 招商加盟-数字物流产业园
    {
      path: '/joinIndustry',
      name: 'joinIndustry',
      component: () => import('@/views/joinIndustry')
    },
    // 招商加盟-
    {
      path: '/joinPlatform',
      name: 'joinPlatform',
      component: () => import('@/views/joinPlatform')
    },
    // 招商加盟-
    {
      path: '/joinPeople',
      name: 'joinPeople',
      component: () => import('@/views/joinPeople')
    },
    // 招商加盟-
    {
      path: '/joinPark',
      name: 'joinPark',
      component: () => import('@/views/joinPark')
    },
    // 联系我们
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/views/contact')
    },
    // 行业动态
    {
      path: '/industryNews',
      name: 'industryNews',
      component: () => import('@/views/industryNews')
    },
    // 万佶动态
    {
      path: '/wanjiNews',
      name: 'wanjiNews',
      component: () => import('@/views/wanjiNews')
    },
    // 万佶动态
    {
      path: '/detailNews',
      name: 'detailNews',
      component: () => import('@/views/detailNews')
    },
    // 加入我们
    {
      path: '/joinUs',
      name: 'joinUs',
      component: () => import('@/views/joinUs')
    },
    
    
  ],
  mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js